import React, { useEffect, useState } from "react";
import { fetchHero } from "./GpImageContainerQuery";
import "./GpImageContainer.css";

const GpImageContainer = () => {
  const [contentItems, setContentItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

  const getImageUrl = (path) =>
    path?.startsWith("http")
      ? encodeURI(path)
      : `${BASE_URL}${encodeURI(path)}`;

  useEffect(() => {
    async function loadData() {
      try {
        const data = await fetchHero();
        const items =
          data?.gpExperiencePage?.[0]?.imageContainers?.contentItems?.filter(
            (item) => item.enabled
          ) || [];

        setContentItems(items);
      } catch (error) {
        console.error("Error loading GP Image Container:", error);
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, []);

  //if (loading) return <p>Loading...</p>;

  return (
    <section className="imgcon-section">
      <div className="imgcon-container">
        {contentItems.map((item, index) => {
          const imageUrl = item?.image?.urls?.[0]
            ? getImageUrl(item.image.urls[0])
            : null;

          const altText = item?.imageAltText || item?.title || "Image";

          const isRight = item.imageOrientation === "Right";

          return (
            <div key={index} className={`imgcon-card ${isRight ? "" : "reverse"}`}>
              <div className="imgcon-text">
                <h2>{item.title}</h2>
                <p>{item.text}</p>
              </div>

              <div className="imgcon-img-wrapper">
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={altText}
                    className="imgcon-img"
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.parentElement.querySelector(".fallback-alt").style.display =
                        "block";
                    }}
                  />
                ) : null}

                {/* Fallback alt text when image doesn't load */}
                <div className="fallback-alt" style={{ display: imageUrl ? "none" : "block" }}>
                  {altText}
                </div>

                <span className="stline top"></span>
                <span className="stline bottom"></span>
                <span className="stline left"></span>
                <span className="stline right"></span>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default GpImageContainer;
